import moment from 'moment'
import { z } from 'zod'

const FAMILY_TIERS = [
  '',
  'single',
  'employee_spouse',
  'employee_children',
  'family'
] as const
const RELATIONSHIPS = ['employee', 'spouse', 'child'] as const

export const censusMemberSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  // will check if DOB is valid date during census upload and inside date picker
  dateOfBirth: z
    .string()
    .min(1, 'Date of birth is required')
    .refine((val) => {
      const isBefore = moment(val, 'MM-DD-YYYY').isBefore()
      return isBefore
    }, 'Date must be in the past'),
  zipCode: z.string().length(5, 'Zip Code must be 5 digits'),
  relationship: z.enum(RELATIONSHIPS),
  gender: z.enum(['male', 'female']),
  familyTier: z.enum(FAMILY_TIERS),
  prevPlanName: z.string().optional()
})

export type ICensusFormMember = z.infer<typeof censusMemberSchema>
